import Filelist from '@/components/common/fileupload/filelist/Filelist.vue'
import ClientContractAgreementEdit from '@/components/client/contract/agreement/edit/ClientContractAgreementEdit.vue'
import { mapState } from 'vuex';

export default {
  name: 'ClientContractListExpand',
  props: {
    data: Object,
    info: Object
  },
  components: {
    Filelist,
    ClientContractAgreementEdit
  },
  data () {
    return {
      loading: false,
      loadingDrns: []
    }
  },
  computed: {
    ...mapState(['config']),
    drnDocuments () {
      return this.ZPFormatHelper.getDrnReportOptions(this.data);
    },
    tableHeaders () {
      const headers = [
        { key: 'contractNumber', label: this.$t('contractAgreement.contractNumber') },
        { key: 'from_date_period_id', label: this.$t('general.filters.date-period-from'), format: 'formatDatePeriod' },
        { key: 'to_date_period_id', label: this.$t('general.filters.date-period-to'), format: 'formatDatePeriod' },
        { key: 'notifyEnding', label: this.$t('contractAgreement.notifyEnding'), format: 'formatYesNo' },
        { key: 'files', label: this.$t('general.file.files'), format: 'filelist', fileReqPath: 'client/files/download/contract-agreement' }
      ];
      if (this.canEdit) {
        headers.push({ key: 'actions', label: '', actions: [{ label: this.$t('menu.contractAgreement.edit'), emit: 'editItem', icon: 'edit', bicon: 'pencil-fill' }] })
      }
      return headers;
    },
    filterActions () {
      const actions = { };
      if (this.canEdit) {
        actions.add = { title: this.$t('menu.contractAgreement.new') };
      }
      return actions;
    },
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-clients');
    },
    tableExpandConfig () {
      return { component: 'ClientContractListExpand', info: { clientApiId: this.info.clientApiId, itemname: 'contract-agreement' } };
    }
  },
  methods: {
    editItem (el) {
      this.$refs.editElFrm.show(el);
    },
    getDrnPdf (pdfCode) {
      this.loadingDrns.push(pdfCode);
      const self = this;
      this.ApiRequest.request('client/single/' + this.info.clientApiId + '/contract/' + this.data.id + '/drn-pdf/' + pdfCode, this.ApiRequest.REQUEST_DOWNLOAD, {}, function (response) {
        const idx = self.loadingDrns.indexOf(pdfCode);
        if (idx >= 0) {
          self.loadingDrns.splice(idx, 1);
        }
      });
    }
  }
}
